import { gql } from '@/store/helpers/axios.js'
import router from '@/router/index.js'

export default {
  async REGISTER ({ state }, formData) {
    /* const {
      firstName,
      lastName,
      email,
      password
    } = formData */

    const query = `mutation registerUser($input: UserRegisterInput!) {
      registerUser(input: $input) {
        user {
          id
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        mitarbeiterId: 0
      }
    }

    const { data } = await gql({ query, variables })

    return data.data.registerUser
  },
  async LOGIN ({ commit, dispatch }, formData) {
    const { email, password } = formData

    const query = `mutation login($input: UserLoginInput!) {
      login(input: $input) {
        requiresTwoFactorAuthentication
        user {
          id
          firstName
          lastName
          mitarbeiterId
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        email,
        password
      }
    }

    const { data } = await gql({ query, variables })
    const { user, requiresTwoFactorAuthentication, errors } = data.data.login

    if (!errors && requiresTwoFactorAuthentication === null) {
      commit('SET_IS_AUTHENTICATED', true)
      commit('SET_CURRENT_USER', user)
      dispatch('GET_MITARBEITER_ADDRESS_ID', user.mitarbeiterId)
    }

    return data.data.login
  },
  async VALIDATE_2FA_TOKEN ({ commit, dispatch }, formData) {
    const { email, password, token } = formData
    const query = `mutation validate2FAToken($input: Validate2FATokenInput!) {
      validate2FAToken(input: $input) {
        user {
          id
          firstName
          lastName
          mitarbeiterId
        }
        errors {
          code
          field
          i18nKey
          message
        }
      }
    }`

    const variables = {
      input: {
        email,
        password,
        token
      }
    }

    const { data } = await gql({ query, variables })
    const { user, errors } = data.data.validate2FAToken

    if (!errors) {
      commit('SET_IS_AUTHENTICATED', true)
      commit('SET_CURRENT_USER', user)
      dispatch('GET_MITARBEITER_ADDRESS_ID', user.mitarbeiterId)
    }

    return data.data.validate2FAToken
  },
  async GET_MITARBEITER_ADDRESS_ID ({ commit }, mitarbeiterId) {
    const query = `query cRMMitarbeiter ($id: Int!){
      response: cRMMitarbeiter (field_001: $id) {
        field_001
        join_user_adress_idId
      }
    }`

    const variables = {
      id: Number(mitarbeiterId)
    }

    const { data } = await gql({ query, variables })
    if (!data.errors) {
      commit('SET_MITARBEITERADDRESSID', data.data.response.join_user_adress_idId)
    }

    return data
  },
  async GET_JOINROLLE_BY_MITARBEITER_ID ({ commit }, { mitarbeiterId }) {
    const query = `query cRMMitarbeiterJOINRollens (
      $where: CRMMitarbeiterJOINRolleFilterInput
      ){
      response: cRMMitarbeiterJOINRollens (where: $where){
        field_001
        rolle_id
        mitarbeiter_id
      }
    }`

    const variables = {
      where: {
        rolle_id: { eq: '1' },
        mitarbeiter_id: { eq: Number(mitarbeiterId) }
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors && data.data.response.length > 0) {
      commit('SET_ADMINROLLE', true)
    }

    return data
  },
  async FORGOT_PASSWORD ({ state }, formData) {
    const { email } = formData

    const query = `mutation userPasswordRecovery($input: UserPasswordRecoveryInput!) {
      userPasswordRecovery(input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        email
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async CHECK_PASSWORD_TOKEN ({ state }, token) {
    const query = `query userPasswordTokenIsValid($input: UserPasswordChangeTokenInput!) {
      userPasswordTokenIsValid(input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        token
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async RESET_PASSWORD ({ state }, formData) {
    const { token, newPassword } = formData

    const query = `mutation userPasswordUpdateByToken($input: UserPasswordChangeByTokenInput!) {
      userPasswordUpdateByToken(input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        token,
        newPassword
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async LOGOUT ({ commit }, type) {
    const query = `mutation logout {
      logout {
        ok
      }
    }`

    await gql({ query })
    commit('SET_CURRENT_USER', {})
    commit('SET_IS_AUTHENTICATED', false)
    router.push({ name: 'login' }).catch(() => {})
  },
  async GET_USERS_AND_ROLES ({ commit }) {
    const query = `query usersAndRoles (
      $where: UserFilter
      ){
      response: usersAndRoles (where: $where){
        firstName
        lastName
        mitarbeiterId
      }
    }`

    const { data } = await gql({ query })

    if (!data.errors) {
      const userArray = []
      for (const user of data.data.response) {
        user.combinedField = user.firstName + ' ' + user.lastName
        userArray.push(user)
      }
      commit('SET_VLAMS_USERS', userArray)
    }

    return data
  }
}
